export interface FinanceReport {
  id: string;
  label: string;
  endpoint: string;
  status: 'live' | 'seeded' | 'planned';
}

export const FINANCE_REPORTS: FinanceReport[] = [
  { id: 'summary',                label: 'Executive Summary',         endpoint: '/api/finance/summary',                 status: 'live' },
  { id: 'settlement-verification', label: 'Settlement Verification',  endpoint: '/api/finance/settlement-verification', status: 'live' },
  { id: 'revenue',                label: 'Revenue Detail',            endpoint: '/api/finance/revenue',                 status: 'live' },
  { id: 'expenses',               label: 'Expense Detail',            endpoint: '/api/finance/expenses',                status: 'live' },
  { id: 'payroll',                label: 'Payroll Report',            endpoint: '/api/finance/payroll',                 status: 'live' },
  { id: 'terminal-pnl',           label: 'Terminal P&L',              endpoint: '/api/finance/terminal-pnl',            status: 'live' },
  { id: 'cashflow',               label: 'Cashflow',                  endpoint: '/api/finance/cashflow',                status: 'live' },
  { id: 'driver-economics',       label: 'Driver Economics',          endpoint: '/api/finance/driver-economics',        status: 'live' },
  { id: 'break-even',             label: 'Break-Even Analysis',       endpoint: '/api/finance/break-even',              status: 'live' },
  { id: 'obligations',            label: 'Obligations & AP',          endpoint: '/api/finance/obligations',             status: 'live' },
];
